enum Action {
    HIDE = 'hide',
    SHOW = 'show',
}

export default Action;
